import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import ImageLoading from "./LoadingComponent/ImageLoading";

const Carousel = (props) => {
  const {data} = props;
  // const { carousels } = useSelector((state) => state.carousels);

  // const [allImagesLoaded, setAllImagesLoaded] = useState(false);
  // const imageRefs = useRef([]);
  const buttonRef = useRef(null);

  const loadedSet = useRef(new Set());

  // const handleImgLoad = (idx) => {
  //   if (!loadedSet.current.has(idx)) {
  //     loadedSet.current.add(idx);

  //     if (loadedSet.current.size === carousels.length) {
  //       setAllImagesLoaded(true);
  //       handleImgLoadHome(true)
  //     }
  //   }
  // };

  // Preload image check (including cached images)
  useEffect(() => {
    loadedSet.current.clear();
    // setAllImagesLoaded(false);
    // imageRefs.current = [];

    if (data.length > 0) {
      const timer = setTimeout(() => {
        // auto advance
        if (buttonRef.current) {
          buttonRef.current.click();
        }
      }, 3000);

      // check if already loaded (from cache)
      // data.forEach((_, idx) => {
      //   const img = imageRefs.current[idx];
      //   if (img && img.complete) {
      //     handleImgLoad(idx);
      //   }
      // });

      return () => clearTimeout(timer);
    }
  }, [data]);

  // if (!allImagesLoaded) {
  //   return (
  //     <div style={{ textAlign: "center", padding: "3rem", height: "80vh" }}>
  //       {/* Hidden preload carousel to make sure all images trigger load */}
  //       <div style={{ display: "none" }}>
  //         {data.map((item, idx) => (
  //           <img
  //             key={idx}
  //             src={item.image}
  //             ref={(el) => (imageRefs.current[idx] = el)}
  //             onLoad={() => handleImgLoad(idx)}
  //             alt={`preload ${idx}`}
  //           />
  //         ))}
  //       </div>

  //       <ImageLoading img={false} />
  //     </div>
  //   );
  // }

  return (
    <div
      id="carouselExampleIndicators"
      className="carousel slide"
      data-bs-ride="carousel"
      data-bs-interval="3000"
    >
      <div className="carousel-indicators">
        {data.map((_, idx) => (
          <button
            key={idx}
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide-to={idx}
            className={idx === 0 ? "active" : ""}
            aria-current={idx === 0 ? "true" : undefined}
            aria-label={`Slide ${idx + 1}`}
          ></button>
        ))}
      </div>

      <div className="carousel-inner">
        {data.map((item, idx) => (
          <div
            key={idx}
            className={`carousel-item ${idx === 0 ? "active" : ""}`}
          >
            <ImageLoading img={true} />
            <img
              src={item.image}
              className="d-block w-100"
              alt="jb architects and engineers"
              loading="lazy"
              // ref={(el) => (imageRefs.current[idx] = el)}
              // onLoad={() => handleImgLoad(idx)}
            />
          </div>
        ))}
      </div>

      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target="#carouselExampleIndicators"
        data-bs-slide="prev"
      >
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>
      <button
        className="carousel-control-next"
        type="button"
        data-bs-target="#carouselExampleIndicators"
        data-bs-slide="next"
        ref={buttonRef}
      >
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button>
    </div>
  );
};

export default Carousel;
